export const PHONE_MASK_PLACEHOLDER = "+7 (999)-999-99-99";

export const maskPhone = (value: string) => {
  const digits = value.replace(/\D/g, "");
  const localDigits = digits.startsWith("7") || digits.startsWith("8")
    ? digits.slice(1, 11)
    : digits.slice(0, 10);

  let result = "+7";

  if (localDigits.length > 0) {
    result += ` (${localDigits.slice(0, 3)}`;
  }

  if (localDigits.length >= 3) {
    result += ")";
  }

  if (localDigits.length > 3) {
    result += `-${localDigits.slice(3, 6)}`;
  }

  if (localDigits.length > 6) {
    result += `-${localDigits.slice(6, 8)}`;
  }

  if (localDigits.length > 8) {
    result += `-${localDigits.slice(8, 10)}`;
  }

  return result;
};

export const normalizeEmailInput = (value: string) => {
  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._%+\-@]/g, "")
    .replace(/@+/g, "@");

  const [name = "", domain = "", ...rest] = normalized.split("@");
  return [domain, ...rest].length > 0
    ? `${name}@${[domain, ...rest].join("")}`
    : name;
};
